import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Callout, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import ContactSupportButton from '~/components/ContactSupportButton';
import ExternalLinkButton from '~/components/ExternalLinkButton';
import { PayoutFailureCode } from '~/models';
import { helpArticles } from '~/utils/helpArticles';
import styles from './PayoutFailedCallout.module.scss';
export const GetPayoutFailedCalloutTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds: {
            PayoutFailedCalloutTID: {
                ChargebacksLink: 'handling-chargebacks-link',
                ContactSupport: 'contact-support'
            }
        }
    });
function getSuffix(code, testIds) {
    switch(code){
        case PayoutFailureCode.MissingAuthorization:
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(ExternalLinkButton, {
                        testId: testIds.ChargebacksLink(),
                        openInNewTab: true,
                        href: helpArticles.chargebacksAndDisputes('missing-auth'),
                        bi: {
                            name: 'handling_chargebacks_learn_more'
                        },
                        children: "Learn more"
                    }),
                    ' ',
                    "about handling chargebacks."
                ]
            });
        default:
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    "For assistance, please ",
                    /*#__PURE__*/ _jsx(ContactSupportButton, {
                        testId: testIds.ContactSupport()
                    }),
                    "."
                ]
            });
    }
}
export default function PayoutFailedCallout(param) {
    let { payout, testId } = param;
    const { PayoutFailedCalloutTID } = useMemo(()=>GetPayoutFailedCalloutTID(), []);
    const payoutFailure = payout.payoutFailure();
    return payoutFailure ? /*#__PURE__*/ _jsx(Callout, {
        testId: testId,
        intent: "warning",
        className: styles.payoutFailedCallout,
        children: /*#__PURE__*/ _jsxs(Typography, {
            children: [
                /*#__PURE__*/ _jsx(Typography, {
                    weight: "bold",
                    as: "span",
                    children: "Payout failed."
                }),
                ' ',
                payoutFailure.message,
                " ",
                getSuffix(payoutFailure.code, PayoutFailedCalloutTID)
            ]
        })
    }) : null;
}
